import Button from '@mui/material/Button';

const PrimaryButton = (props) => {
  return (
    <Button
      id={props.id ? props.id : ''}
      variant="contained"
      type={props.type ? props.type : 'button'}
      onClick={props.onClick}
      className={`primary-button ${props.className ? `${props.className}` : ''}`}
      disabled={props.disabled ? props.disabled : false}
    >
      {props.text}
    </Button>
  )
}

export default PrimaryButton;
